<div class="card-outer">
    <div class="card-inner flex align-items-center justify-content-start gap-4">
        <img
            width="32"
            src="assets/demo/images/new-order.png"
            alt="avatar"
            class="avatar pt-2 pb-2"
        />
        <div
            class="driver-content flex flex-column gap-2 align-items-start justify-content-start"
        >
            <span class="text-600 font-bold text-l">{{
                order.orderDate | date : "short"
            }}</span>
            <span class="text-600 text-xs font-semibold">{{
                order.status | translate
            }}</span>
        </div>

        <div
            class="flex flex-column align-items-end justify-content-end flex-1"
        >
            <div class="text-sm">
                {{ order.numberOfItems }} {{ "item(s)" | translate }}
            </div>
            <span class="active-text text-md font-bold mt-1"
                >MZN {{ order.total }}</span
            >
        </div>
    </div>
</div>
